import {
  Grid,
  Hidden,
  List,
  ListItemButton as MuiListItemButton,
  ListItemButtonProps as MuiListItemButtonProps,
  ListItemText as MuiListItemText,
} from '@mui/material';
import { ElementType, ReactElement } from 'react';
import styled from 'styled-components';

interface ListItemButtonProps extends MuiListItemButtonProps {
  component?: ElementType;
  href?: string;
}

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(0.25)} ${(props) => props.theme.spacing(4)};
  background: ${(props) => props.theme.footer.background};
  position: relative;
  /* z-index must not be negative: it puts the footer behind the content layer
     and makes the Privacy link unclickable */
  z-index: 0;
`;

const ListItemButton = styled(MuiListItemButton)<ListItemButtonProps>`
  display: inline-block;
  width: auto;
  padding: ${(props) => props.theme.spacing(1, 2, 1, 2)};
  height: 38px;
  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`;

function Footer(): ReactElement {
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Hidden mdDown>
          <Grid container item xs={12} md={6}>
            <List sx={{ padding: 0 }}>
              <ListItemButton component="a" href="/privacy">
                <ListItemText primary="Privacy" />
              </ListItemButton>
            </List>
          </Grid>
        </Hidden>
        <Grid container item xs={12} md={6} justifyContent="flex-end">
          <List sx={{ padding: 0 }}>
            <ListItemButton>
              <ListItemText primary={`© ${new Date().getFullYear()} - The Tag System`} />
            </ListItemButton>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
